export default "/assets/website/images/tick.svg?b74c8a6d5ef933a23e3715cfbaa51a04";